<div id="winter_wonder">

  <div class="winter_wonder-banner">
    <div class="go_button winter sm square" style="position:absolute; top:20px; left:20px;">
      <i class="icon-facebook" (click)="eventService.shareEvent()">Share</i>
    </div>
    <img src="assets/img/winter-wonder/WWBannerPC.jpg" class="img-responsive hidden-xs" alt="">

    <img src="assets/img/winter-wonder/WWBannerMobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md"
         alt="">
  </div>

  <div class="container">
    <div class="row" style="margin:10px 0;">

      <h1 style="margin:40px; text-align:center;">Select Game</h1>
      <div class="col-md-3 col-xs-6 game_wrapper">
        <div class="games_block" routerLink="./fortnite" routerLinkActive="active" style="background:url('../../../../assets/img/winter-wonder/Fortnite.png')">
          <img src="assets/img/games/fortnite/logo.png"  width="120" alt="">
        </div>
        <img class="prize" src="assets/img/winter-wonder/Vbucks.png"/>
      </div>

      <div class="col-md-3 col-xs-6 game_wrapper">
        <div class="games_block" routerLink="./league-of-legends" routerLinkActive="active" style="background:url('../../../../assets/img/winter-wonder/Leagueoflegends.png')">
          <img src="assets/img/games/league-of-legends/logo.png" width="120" alt="">
        </div>
        <img class="prize" src="assets/img/winter-wonder/RP.png"/>
      </div>

      <div class="col-md-3 col-xs-12 game_wrapper">
        <div class="games_block" routerLink="./clash-royale" routerLinkActive="active" style="background:url('../../../../assets/img/winter-wonder/ClashRoyale.png')">
          <img src="assets/img/games/clash-royale/logo.png"  width="140" alt="">
        </div>
        <img class="prize" src="assets/img/winter-wonder/Gems.png"/>
      </div>
      <div class="col-md-3 col-xs-12 game_wrapper">
        <div class="games_block" routerLink="./pubg" routerLinkActive="active" style="background:url('../../../../assets/img/winter-wonder/PUBG.png')">
          <img src="assets/img/games/pubg/logo.png"  width="140" alt="">
        </div>
        <img class="prize" src="assets/img/winter-wonder/UC.png"/>
      </div>

    </div>
    <div class="row">
      <h1 style="margin:40px; text-align:center;">Tournaments</h1>

      <router-outlet></router-outlet>
    </div>
  </div>


<div class="winter_wonder_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg"
                                                                         style="width: 80px" alt="GBarena Logo"></a>

  <p>Winter Wonder is hosted and powered by GBarena</p>

  <div style="font-size:18px;">
    <a href="https://facebook.com/gbarena" target="_blank" style="color:#fff">
      <i class="icon-facebook-circled"></i>
    </a>
    <a href="https://twitter.com/gbarenaofficial" target="_blank" style="color:#fff">
      <i class="icon-twitter-circled"></i>
    </a>

    <a href="https://instagram.com/gbarenaofficial" target="_blank" style="color:#fff">
      <i class="icon-instagram-circled"></i>
    </a>

    <a href="http://go.gbarena.com/discord" target="_blank" style="color:#fff; margin-left:5px">
      <img src="../../../../assets/img/icons/discord-logo-white.svg" width="17" />
    </a>
  </div>

</div>
</div>
